module.exports = __webpack_public_path__ + "img/staples-center_la-live1.b3185df7.jpg";